<template>
    <div class="loading">
        <mu-circular-progress :size="32" :stroke-width="2"></mu-circular-progress>
        <p v-if="text">{{ text }}</p>
    </div>
</template>

<script>
    export default {
        name: 'loading',
        props: ['text']
    }
</script>

<style lang="stylus" scoped>

    .loading
        text-align center
        padding 20px 0
        p
            font-size 12px
            margin 4px 0
            color #999

</style>
